module.exports = __webpack_public_path__ + "img/20201006_115925.fc67ce92.jpg";